import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigGithubSettings } from "./app-settings-config-github";

export interface IConfigGithubInputState {
  showModal: boolean;
  editingGithubId: string;
}

export interface IConfigGithubInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigGithubInput extends PureComponent<IConfigGithubInputProps, IConfigGithubInputState> {
  formInputName: string[] = ["apiConfig", "githubSettingsId"];

  constructor(props: IConfigGithubInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingGithubId: ""
    };
  }

  openModal = (): void => {
    this.setState({ showModal: true, editingGithubId: "" });
  };

  closeModal = (): void => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string): void => {
    this.setState({ editingGithubId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render(): ReactNode {
    return (
      <>
        <ConfigGithubSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingGithubId={this.state.editingGithubId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="GitHub"
          formInputName={this.formInputName}
          options={this.props.commonSettings.githubSettings ?? []}
          allowClear
          tooltipContentKey="appsettings_mcp_github"
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="appSettingsMcpGithubDropdown"
          addNewTestId="appSettingsMcpGithubAddNewButton"
          editTestId="appSettingsMcpGithubEditButton"
        />
      </>
    );
  }
}
